import "../css/static.css";
import financialSlide from "../components/home-financial-slide";
import runTooltips from "./static/tooltip.js";
import "./static/record_count.js";
import Cookies from 'js-cookie'
import countdown from "../helpers/countdown.js";

financialSlide();
runTooltips();

(function setUtmCookies(){
  var queryString = new URLSearchParams(window.location.search);

  ['utm_source', 'utm_campaign', 'utm_term', 'utm_device'].map(function(param){
    if (queryString.get(param)) {
      Cookies.set(param, queryString.get(param), { expires: 3 * 365 })
    }
  })
})();

(function() {
  const faqContainer = document.querySelector(".faq");

  if (!faqContainer) {
    return;
  }

  const iconDownUrl = faqContainer.getAttribute("data-icon-down");
  const iconUpUrl = faqContainer.getAttribute("data-icon-up");

  function handleClick(event) {
    const parent = event.currentTarget.parentElement;
    const description = parent.querySelector(".faq-item--description");

    if (description.classList.contains("tw-h-0")) {
      description.style.height = 0;
      description.classList.remove("tw-h-0");
    }

    const isOpen = description.style.height !== "0px";

    parent.querySelector(".faq-item--icon").src = isOpen
      ? iconUpUrl
      : iconDownUrl;

    description.style.height = isOpen ? 0 : `${description.scrollHeight}px`;
    description.classList.toggle("tw-mt-2");
  }

  faqContainer
    .querySelectorAll(".faq-item--button")
    .forEach(button => (button.onclick = handleClick));
})();

(function() {
  const container = document.querySelector(".learn-topics");

  if (!container) {
    return;
  }

  function handleClick(event) {
    const parent = event.currentTarget.parentElement.parentElement;
    const content = parent.querySelector(".learn-topic--content");

    if (content.classList.contains("tw-h-0")) {
      content.style.height = 0;
      content.classList.remove("tw-h-0");
    }

    const isOpen = content.style.height !== "0px";

    content.classList.toggle("tw-mt-12");
    content.style.height = isOpen ? 0 : `${content.scrollHeight}px`;
  }

  container
    .querySelectorAll(".learn-topic--button")
    .forEach(button => (button.onclick = handleClick));
})();

document.addEventListener("DOMContentLoaded", (event) => {
  countdown()
});
